import { audioMessage as message } from "../../Components/Common/Notifications/audioMessage";
import { TrainingAPI } from "../../api/TrainingAPI";
import {mapDataForHighchartsGroupedBar} from "../../mappers/model/GroupedBarChartMapper"
import { displayValidationErrorMessages } from "../../Components/Settings/TeamSettings";
const trainingAPI = new TrainingAPI();

export const TEAM_SET_LOADING = "[TEAM]_SET_LOADING";
export const TEAM_SET_METRIC_DROPDOWNS = '[TEAM]_TEAM_SET_METRIC_DROPDOWNS';
export const TEAM_SET_TESTING_DROPDOWNS = '[TEAM]_SET_TESTING_DROPDOWNS';
export const TEAM_SET_FORCEPLATE_DROPDOWNS = '[TEAM]_SET_FORCEPLATE_DROPDOWNS';
export const TEAM_SET_TEAM_BASIC_INFO = "[TEAM]_SET_TEAM_BASIC_INFO";
export const TEAM_SET_ALL_TEAM_METRICS = "[TEAM]_SET_ALL_TEAM_METRICS";
export const TEAM_SET_POSITIONS = "[TEAM]_SET_POSITIONS";
export const TEAM_SET_ALL_POSITIONS = "[TEAM]_SET_ALL_POSITIONS";
export const TEAM_SET_SPORT = "[TEAM]_SET_SPORT";
export const TEAM_SET_MISC_CONSTANTS = "[TEAM]_SET_MISC_CONSTANTS";
export const TEAM_SET_PLAYERS = "[TEAM]_SET_PLAYERS";
export const TEAM_SET_GAMES = "[TEAM]_SET_GAMES";
export const TEAM_SET_METRICS = "[TEAM]_SET_METRICS";
export const TEAM_SET_COLOR_REF = "[TEAM]_SET_COLOR_REF";
export const TEAM_SET_HAS_WELLNESS = "[TEAM]_SET_HAS_WELLNESS";
export const TEAM_SET_INFORMATION = "[TEAM]_SET_INFORMATION";
export const TEAM_SET_FILTERS = "[TEAM]_SET_FILTERS";
export const TEAM_SET_TRAININGS = "[TEAM]_SET_TRAININGS";
export const TEAM_SET_PRACTICE_PLAN = "[TEAM]_SET_PRACTICE_PLAN";
export const TEAM_SET_DRILL_COST_PER_MIN = "[TEAM]_SET_DRILL_COST_PER_MIN";
export const TEAM_SET_DRILLS = "[TEAM]_SET_DRILLS";
export const TEAM_SET_OVERVIEW_STATS = "[TEAM]_SET_OVERVIEW_STATS";
export const TEAM_SET_CHARTS = "[PLAYER]_PLAYER_SET_CHARTS";
export const TEAM_SET_TESTING_STATS = "[TEAM]_SET_TESTING_STATS";
export const TEAM_SET_TESTING_STAT_DEFAULTS =
	"[TEAM]_SET_TESTING_STAT_DEFAULTS";
export const TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS =
	"[TEAM]_SET_PLAYER_PROFILE_STAT_DEFAULTS";
export const TEAM_SET_FORCEPLATE_STAT_DEFAULTS =
	"[TEAM]_SET_FORCEPLATE_STAT_DEFAULTS";
export const TEAM_SET_WELLNESS_STAT_DEFAULTS =
	"[TEAM]_SET_WELLNESS_STAT_DEFAULTS";
export const TEAM_SET_GPS_STAT_DEFAULTS = "[TEAM]_SET_GPS_STAT_DEFAULTS";
export const TEAM_SET_NUTRITION_STAT_DEFAULTS = "[TEAM]_SET_NUTRITION_STAT_DEFAULTS";
export const TEAM_SET_TESTING_DATA = "[TEAM]_SET_TESTING_DATA";
export const TEAM_SET_TESTING_RARDAR_METRICS =
	"[TEAM]_SET_TESTING_RADAR_METRICS";
export const TEAM_SET_TESTING_RADAR_DATA = "[TEAM]_SET_TESTING_RADAR_DATA";
export const TEAM_SET_TESTING_TABLE_DATA = "[TAEM]_SET_TESTING_TABLE_DATA";
export const TEAM_SET_PLAYER_GROUPS = "[TEAM]_SET_PLAYER_GROUPS";
export const TEAM_SET_FP_DATA = "[TEAM]_SET_FP_DATA";
export const TEAM_SET_FPMS_DATA = "[TEAM]_SET_FPMS_DATA";
export const TEAM_SET_FP_METRICS = "[TEAM]_SET_FP_METRICS";
export const TEAM_SET_REST_TRAVEL_DATES = "[TEAM]_SET_REST_TRAVEL_DATES";
export const TEAM_SET_ALL_PLAYERS = "[TEAM]_SET_ALL_PLAYERS";
export const TEAM_SET_PRESETS = "[TEAM]_SET_PRESETS";

export const TEAM_SET_SCATTERPLOT_FILTERS = "[TEAM]_SET_SCATTERPLOT_FILTERS";
export const TEAM_SET_SCATTERPLOT_DATA = "[TEAM]T_SET_SCATTERPLOT_DATA";
export const TEAM_SET_SCATTERPLOT_ERROR = "[TEAM]_SET_SCATTERPLOT_ERROR";

export const TEAM_SET_PROFILE_PRESET_NAME = "[TEAM]_SET_PROFILE_PRESET_NAME"
export const TEAM_SET_DVAI_SUGGESTED_QUESTIONS = "[TEAM]_SET_DVAI_SUGGESTED_QUESTIONS";
export const TEAM_SET_COLOR_STRATEGIES = "[TEAM]_SET_COLOR_STRATEGIES"

export const setProfilePresetName = (presetName) => {
	return {
		type: TEAM_SET_PROFILE_PRESET_NAME,
		data: presetName
	}
}

export const setDvaiSuggestedQuestions = (data) => {
	return {
		type: TEAM_SET_DVAI_SUGGESTED_QUESTIONS,
		data
	}
}

export const setTeamLoading = (data) => {
	return {
		type: TEAM_SET_LOADING,
		data,
	};
};

export const setMetricDropdowns = (metricType, data) => ({
  type: TEAM_SET_METRIC_DROPDOWNS,
  payload: { metricType, data }
});

export const setTestingDropdowns = (data) => ({
  type: TEAM_SET_TESTING_DROPDOWNS,
  payload: data
});

export const setForceplateDropdowns = (data) => ({
  type: TEAM_SET_FORCEPLATE_DROPDOWNS,
  payload: data
});

export const setTeamInfo = (data) => {
	return {
		type: TEAM_SET_TEAM_BASIC_INFO,
		data,
	};
};

export const setAllTeamMetrics = (data) => {
	return {
		type: TEAM_SET_ALL_TEAM_METRICS,
		data,
	};
};

export const setTeamPositions = (data) => {
	return {
		type: TEAM_SET_POSITIONS,
		data,
	};
};

export const setTeamSport = (data) => {
	return {
		type: TEAM_SET_SPORT,
		data,
	};
};

export const setAllPositions = (data) => {
	return {
		type: TEAM_SET_ALL_POSITIONS,
		data,
	};
};

export const setTeamPlayers = (data) => {
	return {
		type: TEAM_SET_PLAYERS,
		data,
	};
};

export const setTeamGames = (data) => {
	return {
		type: TEAM_SET_GAMES,
		data,
	};
};

export const setTeamMetrics = (data) => {
	return {
		type: TEAM_SET_METRICS,
		data,
	};
};

export const setTeamColorRefs = (data) => {
	return {
		type: TEAM_SET_COLOR_REF,
		data,
	};
};

export const setTeamHasWellness = (data) => {
	return {
		type: TEAM_SET_HAS_WELLNESS,
		data,
	};
};

export const setTeamInformation = (data) => {
	return {
		type: TEAM_SET_INFORMATION,
		data,
	};
};

export const setTeamFilter = (data) => {
	return {
		type: TEAM_SET_FILTERS,
		data,
	};
};

export const setTeamTrainings = (data) => {
	return {
		type: TEAM_SET_TRAININGS,
		data,
	};
};

export const setTeamPracticePlan = (data) => {
	return {
		type: TEAM_SET_PRACTICE_PLAN,
		data,
	};
};

export const setTeamDrillCostPerMin = (data) => {
	return {
		type: TEAM_SET_DRILL_COST_PER_MIN,
		data,
	};
};

export const setTeamDrills = (data) => {
	return {
		type: TEAM_SET_DRILLS,
		data,
	};
};

export const setTeamTestingStats = (data) => {
	return {
		type: TEAM_SET_TESTING_STATS,
		data,
	};
};

export const setTestingStatDefaults = (data) => {
	return {
		type: TEAM_SET_TESTING_STAT_DEFAULTS,
		data,
	};
};

export const setForceplateStatDefaults = (data) => {
	return {
		type: TEAM_SET_FORCEPLATE_STAT_DEFAULTS,
		data,
	};
};

export const setPlayerProfileStatDefaults = (data) => {
	return {
		type: TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS,
		data,
	};
};

export const setWellnessStatDefaults = (data) => {
	return {
		type: TEAM_SET_WELLNESS_STAT_DEFAULTS,
		data,
	};
};

export const setGPSStatDefaults = (data) => {
	return {
		type: TEAM_SET_GPS_STAT_DEFAULTS,
		data,
	};
};

export const setNutritionStatDefaults = (data) => {
	return {
		type: TEAM_SET_NUTRITION_STAT_DEFAULTS,
		data,
	};
};

export const setTeamTestingData = (data) => {
	return {
		type: TEAM_SET_TESTING_DATA,
		data,
	};
};

export const setTeamTestingRadarMetrics = (data) => {
	return {
		type: TEAM_SET_TESTING_RARDAR_METRICS,
		data,
	};
};

export const setTeamTestingRadarData = (data) => {
	return {
		type: TEAM_SET_TESTING_RADAR_DATA,
		data,
	};
};

export const setTeamTestingTableData = (data) => {
	return {
		type: TEAM_SET_TESTING_TABLE_DATA,
		data,
	};
};

export const setTeamPlayerGroups = (data) => {
	return {
		type: TEAM_SET_PLAYER_GROUPS,
		data,
	};
};
export const setTeamFPData = (data) => {
	return {
		type: TEAM_SET_FP_DATA,
		data,
	};
};

export const setTeamFPMSData = (data) => {
  return {
    type: TEAM_SET_FPMS_DATA,
    data,
  };
};

export const setTeamFPMetrics = (data) => {
	return {
		type: TEAM_SET_FP_METRICS,
		data,
	};
};

export const setTeamRestTravelDates = (data) => {
	return {
		type: TEAM_SET_REST_TRAVEL_DATES,
		data,
	};
};

export const setTeamAllPlayers = (data) => {
	return {
		type: TEAM_SET_ALL_PLAYERS,
		data,
	};
};

export const setTeamOverviewStats = (data) => {
	return {
		type: TEAM_SET_OVERVIEW_STATS,
		data,
	};
};

export const getTeamPlayers = () => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ players: true }));
		try {
			const players = await trainingAPI.getAllPlayers(true);
			await dispatch(
				setTeamPlayers(players.filter(({ retired }) => !retired))
			);
			await dispatch(setTeamAllPlayers(players));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ players: false }));
	};
};


export const getTestingDropdowns = () => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getDropdowns({ 
        metricType: ['testing'] 
      });
      if (data.testing_tree) {
        dispatch(setTestingDropdowns(data.testing_tree));
      }
    } catch (error) {
      console.error('Failed to fetch testing dropdowns:', error);
    }
  };
};

export const getForceplateDropdowns = () => {
  return async (dispatch, getState) => {
    try {
      const data = await trainingAPI.getDropdowns({ 
        metricType: ['forceplate'] 
      });
      if (data.forceplate_tree) {
        dispatch(setForceplateDropdowns(data.forceplate_tree));
      }
    } catch (error) {
      console.error('Failed to fetch forceplate dropdowns:', error);
    }
  };
};

export const getTeamInfo = () => async (dispatch) => {
	try {
		const info = await trainingAPI.getTeamInfo();
		dispatch(setTeamInfo(info));
		if (info && Object.keys(info).length > 0 && 'team_colors' in info) {
			dispatch(setTeamColorRefs(info.team_colors));
		}
	} catch (e) {
		throw e;
	}
};

export const getAllTeamMetricsByType = () => async (dispatch) => {
	try {
		const info = await trainingAPI.getTeamMetrics(
			true,
			true,
			true,
			true,
			"all_gps"
		);
		dispatch(setTeamMetrics(info?.filter((x) => x.metric_type === "gps")));
		dispatch(setAllTeamMetrics(info));
	} catch (e) {
		throw e;
	}
};

export const getTeamDrills = () => async (dispatch) => {
	try {
		const drills = await trainingAPI.getDrills();
		await dispatch(setTeamDrills(drills));
	} catch (e) {
		throw e;
	}
};

export const getTeamPositions = () => async (dispatch) => {
	try {
		const { positions, sport } = await trainingAPI.getPositions();
		await dispatch(setTeamPositions(positions));
		await dispatch(setTeamSport(sport));
	} catch (e) {
		throw e;
	}
};

export const getAllPositions = () => async (dispatch) => {
	try {
		const { positions } = await trainingAPI.getPositions(true);
		await dispatch(setAllPositions(positions));
	} catch (e) {
		throw e;
	}
};

export const getTeamPlayerGroups = () => async (dispatch) => {
	try {
		const playerGroups = await trainingAPI.getPlayerGroups();
		await dispatch(setTeamPlayerGroups(playerGroups));
	} catch (e) {
		throw e;
	}
};

export const getTeamGames = () => async (dispatch) => {
	try {
		const games = await trainingAPI.getAllGames();
		await dispatch(setTeamGames(games));
	} catch (e) {
		throw e;
	}
};

export const getTeamMetrics = () => async (dispatch) => {
	try {
		const metrics = await trainingAPI.getTeamMetrics();
		await dispatch(setTeamMetrics(metrics));
	} catch (e) {
		throw e;
	}
};

export const getTeamColors = () => async (dispatch) => {
	try {
		const { team_colors: colorRefs } = await trainingAPI.getTeamInfo();
		await dispatch(setTeamColorRefs(colorRefs));
	} catch (e) {
		throw e;
	}
};

export const getTeamHasWellness = () => async (dispatch) => {
	try {
		const hasWellness = await trainingAPI.getWellnessTeams();
		await dispatch(setTeamHasWellness(hasWellness));
	} catch (e) {
		throw e;
	}
};

export const getTeamDefaultStats = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		if (stats && Object.keys(stats).length > 0) {
			//gps defaults
			dispatch(
				setGPSStatDefaults(
					(stats?.gps || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);

			//testing defaults
			dispatch(setTestingStatDefaults(
				(stats?.testing || [])
				.concat([undefined, undefined, undefined, undefined])
				.slice(0, 4)
			));
			
			//fp defaults
			dispatch(setForceplateStatDefaults(
				(stats?.forceplate || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			));

			//player profile defaults
			let statDefaults;
			if (stats?.profile && Array.isArray(stats?.profile) && stats?.profile.length > 0) {
				// if all strings (older version)
				if (stats?.profile.every(stat => typeof stat === "string" || !stat)) {
					
					if (stats?.profile.length === 8) {
						statDefaults = [[...stats?.profile], [...stats?.profile]];
					} else {
						let tempStat = [...stats?.profile];
						tempStat = tempStat.concat(Array(8 - tempStat.length).fill(undefined));
						statDefaults = [[...tempStat], [...tempStat]];
					}
				} 
				// if all arrays (newer version)
				else if (stats?.profile.every(stat => Array.isArray(stat))) {
					if (stats?.profile.length === 2) {
						let tileStat = [...stats?.profile[0]];
						let chartStat = [...stats?.profile[1]];

						if (tileStat.length < 8) {
							tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
						}

						if (chartStat.length < 8) {
							chartStat = chartStat.concat(Array(8 - chartStat.length).fill(undefined));
						}
						statDefaults = [tileStat, chartStat];
						
					} else {
						let tileStat = [...stats?.profile[0]];
						if (tileStat.length < 8) {
							tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
						}
						statDefaults = [[...tileStat], [...tileStat]];
					}
				}
			} else {
				statDefaults = [
					[
						undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
					],
					[
						undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
					]
				];
			}
			dispatch(setPlayerProfileStatDefaults(statDefaults));
			
			//wellness defaults
			dispatch(
				setWellnessStatDefaults(
					(stats?.subjective || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);

			//nutrition defaults
			dispatch(
				setNutritionStatDefaults(
					(stats?.nutrition || [])
						.concat([undefined, undefined, undefined, undefined])
						.slice(0, 4)
				)
			);


		}
		
	} catch (e) {
		throw e;
	}
};

export const getTeamTestingStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		const testingStatDefaults = (stats?.testing || []).concat([undefined, undefined, undefined, undefined]).slice(0, 4);
		await dispatch(setTestingStatDefaults(testingStatDefaults));
	} catch (e) {
		throw e;
	}
};

export const getTeamForceplateStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setForceplateStatDefaults(
				(stats?.forceplate || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getTeamPlayerProfileStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		let statDefaults;
		if (stats?.profile && Array.isArray(stats?.profile) && stats?.profile.length > 0) {
			// if all strings (older version)
			if (stats?.profile.every(stat => typeof stat === "string" || !stat)) {
				
				if (stats?.profile.length === 8) {
					statDefaults = [[...stats?.profile], [...stats?.profile]];
				} else {
					let tempStat = [...stats?.profile];
					tempStat = tempStat.concat(Array(8 - tempStat.length).fill(undefined));
					statDefaults = [[...tempStat], [...tempStat]];
				}
			} 
			// if all arrays (newer version)
			else if (stats?.profile.every(stat => Array.isArray(stat))) {
				if (stats?.profile.length === 2) {
					let tileStat = [...stats?.profile[0]];
					let chartStat = [...stats?.profile[1]];

					if (tileStat.length < 8) {
						tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
					}

					if (chartStat.length < 8) {
						chartStat = chartStat.concat(Array(8 - chartStat.length).fill(undefined));
					}
					statDefaults = [tileStat, chartStat];
					
				} else {
					let tileStat = [...stats?.profile[0]];
					if (tileStat.length < 8) {
						tileStat = tileStat.concat(Array(8 - tileStat.length).fill(undefined));
					}
					statDefaults = [[...tileStat], [...tileStat]];
				}
			}
		} else {
			statDefaults = [
				[
					undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
				],
				[
					undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
				]
			]
		}

		await dispatch(setPlayerProfileStatDefaults(statDefaults));
	} catch (e) {
		throw e;
	}
};
			
export const getWellnessStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setWellnessStatDefaults(
				(stats?.subjective || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getGPSStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setGPSStatDefaults(
				(stats?.gps || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getNutritionStatDefaults = () => async (dispatch) => {
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(
			setNutritionStatDefaults(
				(stats?.nutrition || [])
					.concat([undefined, undefined, undefined, undefined])
					.slice(0, 4)
			)
		);
	} catch (e) {
		throw e;
	}
};

export const getChatbotSuggestedQuestions = () => async (dispatch) => {
	try {
		const data = await trainingAPI.getChatbotSuggestedQuestions();
		if (data === "No action performed") {
			// no questions available
			return;
		}
		await dispatch(setDvaiSuggestedQuestions(data || []));
	} catch (e) {
		console.warn("Error fetching chatbot suggested questions:", e);
		// do nothing, this is not critical
	}
}

export const getTeamOverviewDefaults = () => async (dispatch) => {
	dispatch(setTeamLoading({ overviewStats: true }));
	try {
		const stats = await trainingAPI.getDefaultStats();
		await dispatch(setTeamOverviewStats(stats?.overview || []));
	} catch (e) {
		throw e;
	}
	dispatch(setTeamLoading({ overviewStats: false }));
};

export const getTeamRestTravelDates = () => async (dispatch) => {
	try {
		const data = await trainingAPI.getRestTravelDates();
		await dispatch(setTeamRestTravelDates(data));
	} catch (e) {
		throw e;
	}
};

export const getTeamInformation = () => {
	return async (dispatch) => {
		dispatch(setTeamLoading({ info: true }));
		try {
			await Promise.all([
				dispatch(getTeamInfo()), //needed for ACWR table (coachlist, ACWR limits, name)
				dispatch(getTeamDrills()), //needed for getting prediction info
				dispatch(getTeamPositions()), //needed for ACWR table position filter
				dispatch(getTeamPlayers()), //needed for ACWR table
				dispatch(getAllTeamMetricsByType()), //needed for add prediction dialog
				dispatch(getTeamRestTravelDates()), //needed for cell badges
			]);

			// fire-and-forget api calls
            dispatch(getTeamPlayerGroups());
            dispatch(getTeamHasWellness());
            dispatch(getTeamDefaultStats()); //combines gps, fp, testing, wellness, nutrition, profile
            dispatch(getTeamGames());
			dispatch(getChatbotSuggestedQuestions());
			dispatch(getColorStrategies());

			// const info = await trainingAPI.getTeamInfo();
			// const drills = await trainingAPI.getDrills();
			// const { positions } = await trainingAPI.getPositions();
			// const players = await trainingAPI.getAllPlayers(false);
			// const playerGroups = await trainingAPI.getPlayerGroups();
			// const games = await trainingAPI.getAllGames();
			// const metrics = await trainingAPI.getTeamMetrics();
			// const { colors: colorRefs } = await trainingAPI.getYearTrainings();
			// const hasWellness = await trainingAPI.getWellnessTeams();
			// const testingStatDefaults = (await trainingAPI.getDefaultTestingStats())
			//   .concat([undefined, undefined, undefined, undefined])
			//   .slice(0, 4);
			// const forceplateStatDefaults = (
			//   await trainingAPI.getDefaultForcePlateStats()
			// )
			//   .concat([undefined, undefined, undefined, undefined])
			//   .slice(0, 4);
			// await dispatch(
			//   setTeamInformation({
			//     info,
			//     drills,
			//     positions,
			//     players,
			//     playerGroups,
			//     games,
			//     metrics,
			//     colorRefs,
			//     hasWellness,
			//     testingStatDefaults,
			//     forceplateStatDefaults,
			//   })
			// );
		} catch (e) {
			console.error(e);
		}
		dispatch(setTeamLoading({ info: false }));
	};
};

export const getTeamGPSData = (force_weekly = false) => {
	return async (dispatch, getState) => {
		await dispatch(setTeamLoading({ gps: true }));
		try {
			const { filter } = getState().team;
			const trainings = await trainingAPI.getTrainings({
				start_date: filter.startDate,
				end_date: filter.endDate,
				weekly: filter.showWeekly || force_weekly,
				pos_filter: filter.position,
				player_group: filter.player_group,
				session_filter: filter.session,
				show_predictions: filter.showPredictions,
			});
			dispatch(setTeamTrainings(trainings));

			const practicePlan = await trainingAPI.getPracticePlan(
				filter.startDate,
				filter.endDate
			);
			dispatch(setTeamPracticePlan(practicePlan));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ gps: false }));
	};
};

export const getLastPracticePlanDate = async () => {
	try {
		const { date } = await trainingAPI.getPracticePlan();
		return date;
	} catch (e) {
		console.error(e);
	}
};

export const getTeamDrillCostPerMin = () => {
	return async (dispatch) => {
		try {
			const data = await trainingAPI.getDrillCostPerMin();
			dispatch(setTeamDrillCostPerMin(data));
		} catch (err) {
			console.error(err);
		}
	};
};

export const getPlayerGroups = () => {
	return async (dispatch) => {
		try {
			const data = await trainingAPI.getPlayerGroups();
			dispatch(setTeamInformation(data));
		} catch (err) {
			console.error(err);
		}
	};
};

export const getTeamTestingRadarData = () => {
	return async (dispatch, getState) => {
		await dispatch(setTeamLoading({ testingRadar: true }));
		try {
			const { filter, radarMetrics } = getState().team;
			if (!radarMetrics.every( (metric) => metric?.includes("-"))) {
				throw new Error(`Invalid metric found in radarMetrics list: ${radarMetrics?.join(", ")}`);
			}
			const data = await trainingAPI.getRadarData({
				start_date: filter.startDate,
				end_date: filter.endDate,
				metrics: radarMetrics,
				pos_filter: filter.position,
				player_group: filter.player_group,
				sessions: filter.session
		});
		dispatch(setTeamTestingRadarData(data));
		} catch (e) {
			console.error(e);
		}
		await dispatch(setTeamLoading({ testingRadar: false }));
	};
};

export const getTeamMovementSignatureData = () => {
  return async (dispatch, getState) => {
    await dispatch(setTeamLoading({ fpmsData: true }));
    try {
      const { filter } = getState().team;
      const data = await trainingAPI.getTestingData({
				  start_date: filter.startDate,
					end_date: filter.endDate,
					pos_filter: filter.position,
					stats: filter.forceplateStats ? "Max" : "Avg",
					player_group: filter.player_group || undefined,
					sessions: filter.session,
					metric_type: "forceplate",
					is_movement_sig: true
				}
      );
      dispatch(setTeamFPMSData(data));
    } catch (e) {
      console.error(e);
    }
    await dispatch(setTeamLoading({ fpmsData: false }));
  };
};

export const changeTeamFPMetric = (key, value) => {
	return async (dispatch, getState) => {
		let metrics = [...getState().team.fpMetrics];
		metrics[key] = value;
		await dispatch(setTeamFPMetrics(metrics));
	};
};

export const saveRestTravelDates = (data) => {
	return async (dispatch) => {
		try {
			await trainingAPI.saveRestTravelDates(data);
			await dispatch(getTeamRestTravelDates());
			message.success("Changes Saved");
		} catch (e) {
			message.error("Error");
			console.error(e);
		}
	};
};

export const addTeamPlayer = (playerData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Adding player" }));
		try {
			await trainingAPI.addPlayers(playerData);
			await dispatch(getTeamPlayers());
			message.success("Added the player");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error adding the player");
			}
		}

		try {
			const errorMessages = await trainingAPI.validateTeam();
			if(errorMessages && Array.isArray(errorMessages)) {
			  	displayValidationErrorMessages(errorMessages)
			}
		} catch (error) {
			message.error("Error performing team validation");
		}

		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const editTeamPlayer = (playerData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Editing player" }));
		try {
			await trainingAPI.editPlayer(playerData);
			await dispatch(getTeamPlayers());
			message.success("Edited the player");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error editing the player");
			}
		}

		try {
			const errorMessages = await trainingAPI.validateTeam();
			if(errorMessages && Array.isArray(errorMessages)) {
			  	displayValidationErrorMessages(errorMessages)
			}
		} catch (error) {
			message.error("Error performing team validation");
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const editTeamPlayers = (players) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Editing players" }));
		try {
			await Promise.all(players.map(trainingAPI.editPlayer));
			message.success("Success");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error editing players");
			}
		}

		try {
			const errorMessages = await trainingAPI.validateTeam();
			if(errorMessages && Array.isArray(errorMessages)) {
			  	displayValidationErrorMessages(errorMessages)
			}
		} catch (error) {
			message.error("Error performing team validation");
		}

		await dispatch(getTeamPlayers());
		const activePlayers = players?.filter(player => !player?.retired) || [];
		await dispatch(setTeamPlayers(activePlayers))
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const uploadBulkPlayers = (file) => {
	return async (dispatch) => {
		await dispatch(
			setTeamLoading({ onboarding: "Uploading players from csv file" })
		);
		try {
			await trainingAPI.uploadPlayerCsv(file);
			message.success("File uploaded successfully");
			await dispatch(getTeamPlayers());
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error uploading file");
			}
		}

		try {
			const errorMessages = await trainingAPI.validateTeam();
			if(errorMessages && Array.isArray(errorMessages)) {
			  	displayValidationErrorMessages(errorMessages)
			}
		} catch (error) {
			message.error("Error performing team validation");
		}

		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const deletePlayer = (player_id) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting player" }));
		try {
			await trainingAPI.deletePlayer(player_id);
			await dispatch(getTeamPlayers());
			message.success("Deleted player successfully");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error deleting the player");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const sendWelcomeEmailToPlayer = (player_id) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Sending welcome email" }));
		try {
			await trainingAPI.sendWelcomeEmail(player_id);
			message.success("Welcome email was sent successfully");
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error("Error sending welcome email to the player");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const deletePlayers = (ids) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting players" }));
		try {
			await Promise.all(ids.map(trainingAPI.deletePlayer));
			await dispatch(getTeamPlayers());
			message.success("Success");
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error deleting players");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const setMiscConstants = (data) => {
  return {
    type: TEAM_SET_MISC_CONSTANTS,
    data,
  };
};

export const getTeamPresets = (params) => {
	return async (dispatch, getState) => {
		try {
			const presets = await trainingAPI.getPresets(params);
      		dispatch(setTeamPresets(presets))
		} catch (err) {
			console.error(err);
		}
	};
};

export const setTeamPresets = (data) => {
	return {
	  type: TEAM_SET_PRESETS,
	  data,
	};
};

export const getScatterplotData = () => {
	return async (dispatch, getState) => {
		try {

			const {
				scatterplot_filters: { startDate, endDate, xAxisMetric, yAxisMetric, playerSelections, groupByGameDate, useAvgValues }
			} = getState().team;

			const payload = {
				start_date: startDate?.format ? startDate.format("YYYY-MM-DD") : startDate?.split("T")?.[0],
				end_date: endDate?.format ? endDate.format("YYYY-MM-DD") : endDate?.split("T")?.[0],
				x_axis_metric: xAxisMetric,
				y_axis_metric: yAxisMetric,
				player_selection: playerSelections,
				group_by_game_date: groupByGameDate,
				use_avg_values: useAvgValues
			}
			const scatterplotData = await trainingAPI.getScatterplotData(payload);
			dispatch(setScatterplotData(scatterplotData));
		} catch (err) {
			console.error(err);
		}
	};
};

export const setScatterplotFilters = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_FILTERS,
	  data,
	};
};

export const setScatterplotError = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_ERROR,
	  data,
	};
};

export const setScatterplotData = (data) => {
	return {
	  type: TEAM_SET_SCATTERPLOT_DATA,
	  data,
	};
};

export const addTeamCoach = (coachData) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Adding coach" }));
		try {
			await trainingAPI.addCoach(coachData).then(res => {
				message.success(res);
			});
			await dispatch(getTeamInfo());
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data)
				message.error(e.response.data);
			else {
				message.error("Error adding coach");
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};


export const sendWelcomeEmailToCoach = (coachEmail) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Sending welcome email to coach" }));
		try {
			const res = await trainingAPI.sendWelcomeEmailCoach(coachEmail);
			message.success(`${coachEmail}: ${res}`);
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error sending welcome email to: ${coachEmail}`);
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};


export const deleteCoach = (coachEmail) => {
	return async (dispatch) => {
		await dispatch(setTeamLoading({ onboarding: "Deleting Coach" }));
		try {
			await trainingAPI.deleteCoach(coachEmail);
			message.success(`Successfully deleted coach!`);
			await dispatch(getTeamInfo());
			await dispatch(setTeamLoading({ onboarding: null }));
			return true;
		} catch (e) {
			if (e.response && e.response.status < 500 && e.response.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error deleting coach ${coachEmail}`);
			}
		}
		await dispatch(setTeamLoading({ onboarding: null }));
	};
};

export const setColorStrategies = (data) => {
	return {
		type: TEAM_SET_COLOR_STRATEGIES,
		data,
	};
};

export const getColorStrategies = () => {
	return async (dispatch) => {
		try {
			const strategies = await trainingAPI.getColorStrategies();
			dispatch(setColorStrategies(strategies));
			return strategies;
		} catch (error) {
			console.error("Error fetching color strategies:", error);
			if (e?.response?.status < 500 && e?.response?.data) {
				message.error(e.response.data);
			} else {
				message.error(`Error fetching color strategies`);
			}
			return [];
		}
	};
};

export const updateDifficultyBarConfig = (data) => async (dispatch) => {
  try {
    await trainingAPI.updateDifficultyBarConfig(data);
    dispatch(getTeamInfo());
    return true;
  } catch (error) {
    console.error("Error updating misc constants:", error);
    throw error;
  }
};

